import Commands from './commands';

class Get extends Commands {
    constructor(registry) {
        super("get", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        return this.registry.get(key);
    }
}

export default Get;
